import { render, staticRenderFns } from "./CustomerBugNotification.vue?vue&type=template&id=2433e476&scoped=true&"
import script from "./CustomerBugNotification.vue?vue&type=script&lang=js&"
export * from "./CustomerBugNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2433e476",
  null
  
)

export default component.exports